import { api } from '../../plugins/api'

export default {
    loadEvent () {
        api
            .get('evenement/4')
            .then((response) => {
                commit('setListeEvenements', response.data)
            })
            .finally(() => {
                commit('setState', {field: 'listeEvenementsEnChargement', value: false})
            })
    },
    loadProgrammes () {

    },
    loadTarifs () {

    }

}